import Request from '../Request.utils'
export interface IGetOrderExecutionRequestParams {
  orderReference: string;
}
export interface IGetDriverDetailRequestParams {
  driverReference: string;
}
export interface IGetOrderDetailRequestQuery {
  orderReference: string;
}
export interface IRefreshBackOrderDataRequestBody {
  orderId?: string;
  orderReference?: string;
}
export interface IImportByReferrenceNumberRequestBody {
  isDryRun?: boolean;
  referrenceNumbers: string[];
}


class MaxoptraAPI {
  orderStatusUpdated = async () => {
    const res = await Request.call('/api/maxoptra/order-status-updated', 'POST', undefined, undefined, undefined, );
    return res;
  }
  scheduleUpdated = async () => {
    const res = await Request.call('/api/maxoptra/schedule-updated', 'POST', undefined, undefined, undefined, );
    return res;
  }
  runStatusUpdated = async () => {
    const res = await Request.call('/api/maxoptra/run-status-updated', 'POST', undefined, undefined, undefined, );
    return res;
  }
  shopifyWebhook = async () => {
    const res = await Request.call('/api/maxoptra/shopify-webhook', 'POST', undefined, undefined, undefined, );
    return res;
  }
  whatsappWebhook = async () => {
    const res = await Request.call('/api/maxoptra/whatsapp-webhook', 'POST', undefined, undefined, undefined, );
    return res;
  }
  testSubmitMaxOptra = async () => {
    const res = await Request.call('/api/maxoptra/test-submit-maxoptra', 'POST', undefined, undefined, undefined, );
    return res;
  }
  getOrderExecution = async (params: IGetOrderExecutionRequestParams) => {
    const res = await Request.call('/api/maxoptra/order-execution/:orderReference', 'GET', params, undefined, undefined, );
    return res;
  }
  getDriverDetail = async (params: IGetDriverDetailRequestParams) => {
    const res = await Request.call('/api/maxoptra/driver-detail/:driverReference', 'GET', params, undefined, undefined, );
    return res;
  }
  getOrderDetail = async (query: IGetOrderDetailRequestQuery) => {
    const res = await Request.call('/api/maxoptra/order-detail', 'GET', undefined, query, undefined, );
    return res;
  }
  refreshBackOrderData = async (body: IRefreshBackOrderDataRequestBody) => {
    const res = await Request.call('/api/maxoptra/refresh-back-order-data', 'POST', undefined, undefined, body, );
    return res;
  }
  syncMaxoptraDelivery = async () => {
    const res = await Request.call('/api/maxoptra/sync-all-orders', 'POST', undefined, undefined, undefined, );
    return res;
  }
  syncApcDelivery = async () => {
    const res = await Request.call('/api/maxoptra/sync-apc-deliveries', 'POST', undefined, undefined, undefined, );
    return res;
  }
  importByReferrenceNumber = async (body: IImportByReferrenceNumberRequestBody) => {
    const res = await Request.call('/api/maxoptra/import-by-referrence-number', 'POST', undefined, undefined, body, );
    return res;
  }
}
export default new MaxoptraAPI()